import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { fromJS } from "immutable";
import * as queryString from "query-string";
import { CommonGameController } from "component/common";
import { FloatingGamesLayout } from "component/menu";
import CommonMultiGameController, {
  GamesLayoutType,
} from "component/common/MultiGameController";
import { CategoryListItem, CategoryType8ListItem } from "component/listItem";
import { CategoryFiltersComponent } from "component/filters";
import { GameItem, GameItemBanner } from "component/game";
import { GamesList, CategoryGames } from "component/list";
import { LobbyGameNavigation } from "component/lobby";
import { CategoryType9ListItem } from "component/listItem";
import { Info } from "component/details";
import { ReactComponent as CloseIcon } from "assets/icons/x-icon.svg";
import { isEmpty } from "lodash";
import { getSortedIndexes } from "utils/list";
import RoundHistoryPerGame from "containers/RoundHistoryPerGame";

import "containers/Games/styles.scss";
import ShowMoreFilters from "containers/ShowMoreFilters";

class Games extends Component {
  constructor(props) {
    super(props);
    this.containerRef = createRef();
    this.gamesRef = createRef();
    this.ghostRef = createRef();
    this.controllerRef = createRef();
    this.launchGame = this._launchGame.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.onCloseGameHandler = this._onCloseGameHandler.bind(this);
    this.setGameInfo = this._setGameInfo.bind(this);
    this.setGameHistory = this._setGameHistory.bind(this);
    this.setGameHistoryShow = this._setGameHistoryShow.bind(this);
    this.setGameInfoShow = this._setGameInfoShow.bind(this);
    this.setGameRelatedLinks = this._setGameRelatedLinks.bind(this);
    this.onFullscreenHandler = this._onFullscreenHandler.bind(this);
    this.fullscreenChangeHandler = this._fullscreenChangeHandler.bind(this);
    this.setMultiGame = this._setMultiGame.bind(this);
    this.onRefreshClickHandler = this._onRefreshClickHandler.bind(this);
    this.onRotateClickHandler = this._onRotateClickHandler.bind(this);
    this.onDraggingItem = this._onDraggingItem.bind(this);
    this.onDrop = this._onDrop.bind(this);
    this.onDragOver = this._onDragOver.bind(this);
    this.onDragEnd = this._onDragEnd.bind(this);
    this.setMiniLobby = this._setMiniLobby.bind(this);
    this.renderMiniLobby = this._renderMiniLobby.bind(this);
    this.renderInfoPanel = this._renderInfoPanel.bind(this);
    this.onPreviousClick = this._onPreviousClick.bind(this);
    this.closeRoundHistoryModal = this._closeRoundHistoryModal.bind(this);

    this.state = {
      multiGameCount: 1,
      draggedItem: null,
      itemOrder: [0, 1, 2, 3],
      gameInfos: fromJS({}),
      gameHistories: fromJS({}),
      gameInfosShow: fromJS({}),
      gameRelatedLinks: fromJS({}),
      gameMiniLobbys: fromJS({}),
      selectedFilters: null,
      showFilters: false,
      showController: false,
      isHovered: false,
      hoverId: null,
      gameHistoryModals: fromJS({}),
      modalAnimationState: fromJS({}),
    };
  }

  _setMiniLobby(id, content) {
    let games = this.props.games;
    games = games.setIn([id, "data"], content);

    let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

    let params = {
      games: gamesEnc,
      layout: this.props.gamesLayout,
    };

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _setGameInfo(game) {
    let newGameInfos = this.state.gameInfos;
    newGameInfos = newGameInfos.setIn([game.get("gameId")], game);
    this.setState({
      gameInfos: newGameInfos,
    });
  }

  _setGameHistory(game) {
    let newGameHistories = this.state.gameHistories;
    newGameHistories = newGameHistories.setIn([game.get("gameId")], game);
    this.setState({
      gameHistories: newGameHistories,
    });
  }

  _setGameInfoShow(game) {
    let newGameInfosShow = this.state.gameInfosShow;
    let show =
      newGameInfosShow.getIn([game.get("gameId")]) === undefined
        ? true
        : !newGameInfosShow.getIn([game.get("gameId")]);

    newGameInfosShow = newGameInfosShow.setIn([game.get("gameId")], show);
    this.setState({
      gameInfosShow: newGameInfosShow,
    });
  }

  _setGameRelatedLinks(game, route, params) {
    this.props.fetchRelatedLinks(route, params).then((resp) => {
      let newGameRelatedLinks = this.state.gameRelatedLinks;
      newGameRelatedLinks = newGameRelatedLinks.setIn(
        [game.get("gameId")],
        fromJS(resp)
      );
      this.setState({
        gameRelatedLinks: newGameRelatedLinks,
      });
      return resp;
    });
  }

  _launchGame(i, gameParam) {
    let games = this.props.games.setIn([i], gameParam);

    let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

    let params = {
      games: gamesEnc,
      layout: this.props.gamesLayout,
    };

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;

    this.props.navigateTo(newLoc);
  }

  _onCloseClickHandler() {
    this.props.fetchBalance();
    this.props.onGameClose({
      location: this.props.location,
    });
    this.setState({
      multiGameView: null,
      multiGameCount: 1,
      multiGameLayout: GamesLayoutType.LAYOUT_1,
      relatedLinks: null,
      relatedParams: null,
      relatedRoute: null,
      draggedItem: null,
      itemOrder: [0, 1, 2, 3],
      gameInfos: fromJS({}),
      gameInfosShow: fromJS({}),
      gameRelatedLinks: fromJS({}),
      gameHistoryModals: fromJS({}),
    });
    let search = queryString.parse(this.props.location.search);
    delete search.games;
    delete search.layout;
    this.props.navigateTo(`${this.props.location.pathname}`);
  }

  _onCloseGameHandler(i) {
    let games = this.props.games.setIn([i], {
      type: "lobby",
      data: this.props.lobbyContent.getIn([0]),
    });

    let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

    let params = {
      games: gamesEnc,
      layout: this.props.gamesLayout,
    };

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;

    this.props.navigateTo(newLoc);
  }

  _onRefreshClickHandler(i) {
    let game = this.props.games.getIn([i]);
    if (game.get("type") === "lobby") {
      let filterLinkIndex;
      let newFilterLink = game.getIn(["data", "links"]).find((link, index) => {
        let isFilterLink = link.get("rel").indexOf("filters") > -1;
        if (isFilterLink) filterLinkIndex = index;
        return isFilterLink;
      });
      newFilterLink = newFilterLink.setIn(
        ["refresh"],
        newFilterLink.getIn(["refresh"])
          ? newFilterLink.getIn(["refresh"]) + 1
          : 1
      );
      this.props.deleteFilterCategory(
        `minilobby.${i}.${newFilterLink.get("rel")}`
      );
      game = game.setIn(["data", "links", filterLinkIndex], newFilterLink);
    } else {
      game = game.setIn(
        ["refresh"],
        game.getIn(["refresh"]) ? game.getIn(["refresh"]) + 1 : 1
      );
    }

    let games = this.props.games.setIn([i], game);
    let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

    let params = {
      games: gamesEnc,
      layout: this.props.gamesLayout,
    };

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;

    this.props.navigateTo(newLoc);
  }

  _onRotateClickHandler(i) {
    let game = this.props.games.getIn([i]);
    game = game.setIn(
      ["deviceType"],
      game.getIn(["deviceType"]) ? game.getIn(["deviceType"]) + 1 : 1
    );
    let games = this.props.games.setIn([i], game);
    let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

    let params = {
      games: gamesEnc,
      layout: this.props.gamesLayout,
    };

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;

    this.props.navigateTo(newLoc);
  }

  _onFullscreenHandler(bol) {
    let elem = this.containerRef.current;
    this.props.setGameFullscreen(bol);
    if (bol) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    } else {
      if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    }
  }

  _fullscreenChangeHandler(event) {
    if (document.webkitIsFullScreen === false) {
      this.onFullscreenHandler(false);
    } else if (document.mozFullScreen === false) {
      this.onFullscreenHandler(false);
    } else if (document.msFullscreenElement === false) {
      this.onFullscreenHandler(false);
    }
  }

  _setMultiGame(i, layout) {
    let games = this.props.games;

    this.props.games.forEach((game, key) => {
      let count = i - 1;
      if (key <= count) {
        if (!games.getIn([key])) {
          games = games.setIn([key], {
            type: "lobby",
            data: this.props.lobbyContent.getIn([0]),
          });
        }
      } else {
        games = games.setIn([key], null);
      }
    });

    let gamesEnc = btoa(encodeURIComponent(JSON.stringify(games.toJSON())));

    let params = {
      games: gamesEnc,
      layout,
    };

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;

    let newItemOrder = this.state.itemOrder;
    newItemOrder = newItemOrder.filter((value, index) => {
      return games.get(index) !== null;
    });

    let sortedIndex = getSortedIndexes(newItemOrder, 4);

    this.props.navigateTo(newLoc);
    this.setState({
      itemOrder: sortedIndex,
      multiGameCount: i,
    });
  }

  componentDidMount() {
    document.addEventListener("fullscreenchange", this.fullscreenChangeHandler);

    if (!this.props.games) return;

    let size = this.props.games.findLastIndex((game) => {
      return game !== null;
    });

    this.setState({
      multiGameCount: size + 1,
    });
  }

  componentWillUnmount() {
    document.removeEventListener(
      "fullscreenchange",
      this.fullscreenChangeHandler
    );
  }

  _onDraggingItem(event) {
    this.setState({
      draggedItem: event.currentTarget,
    });

    event.currentTarget.style.zIndex = "999999";
  }

  _onDragEnd(event) {
    event.preventDefault();
    event.currentTarget.style.zIndex = "auto";
  }

  _onDragOver(event) {
    event.preventDefault();
  }

  swapOrder(array, index1, index2) {
    let temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;

    return array;
  }

  _onDrop(event) {
    let draggedOrder = Number(
      window.getComputedStyle(this.state.draggedItem).getPropertyValue("order")
    );
    let draggedIndex = this.state.itemOrder.indexOf(draggedOrder);
    let droppedOrder = Number(
      window.getComputedStyle(event.currentTarget).getPropertyValue("order")
    );
    let droppedIndex = this.state.itemOrder.indexOf(droppedOrder);

    let newArr = this.swapOrder(
      this.state.itemOrder,
      draggedIndex,
      droppedIndex
    );
    this.setState({
      itemOrder: newArr,
    });
  }

  handleMouseEnter = (gameId) => {
    this.setState({
      isHovered: true,
      hoverId: gameId,
    });
  };

  handleMouseLeave = (gameId) => {
    this.setState({
      isHovered: false,
      hoverId: gameId,
    });
  };

  _setGameHistoryShow(gameItem) {
    const gameId = gameItem.get("gameId");

    this.setState(
      (prevState) => ({
        gameHistoryModals: prevState.gameHistoryModals.set(gameId, true),
        modalAnimationState: prevState.modalAnimationState.set(
          gameId,
          "opening"
        ),
      }),
      () => {
        setTimeout(() => {
          this.setState((prevState) => ({
            modalAnimationState: prevState.modalAnimationState.set(
              gameId,
              "open"
            ),
          }));
        }, 300);
      }
    );
  }

  _closeRoundHistoryModal(gameId) {
    this.setState(
      (prevState) => ({
        modalAnimationState: prevState.modalAnimationState.set(
          gameId,
          "closing"
        ),
      }),
      () => {
        setTimeout(() => {
          this.setState((prevState) => ({
            gameHistoryModals: prevState.gameHistoryModals.set(gameId, false),
            modalAnimationState: prevState.modalAnimationState.set(
              gameId,
              null
            ),
          }));
        }, 300);
      }
    );
  }

  _renderInfoPanel(i, game) {
    let gameId;
    let gameInfo;
    let gameInfoShow;
    let gameRelatedLinks;
    try {
      gameId = game.get("gameId");
    } catch (err) {}
    try {
      gameInfo = this.state.gameInfos.get(gameId);
    } catch (err) {}
    try {
      gameInfoShow = this.state.gameInfosShow.get(gameId);
    } catch (err) {}
    try {
      gameRelatedLinks = this.state.gameRelatedLinks.get(gameId);
    } catch (err) {}
    try {
      const controllerEl = this.containerRef.current.querySelector(
        `.game-controller.${gameId}`
      );
      if (
        (controllerEl &&
          controllerEl.className.includes(this.state.hoverId) &&
          this.state.isHovered) ||
        this.props.isMobile
      ) {
        controllerEl.style.opacity = "1";
      } else {
        controllerEl.style.opacity = "0";
      }
    } catch (err) {}

    return (
      <div
        className={`info-panel-background ${
          this.state.multiGameCount > 1 ? "multi-game" : ""
        } ${gameInfoShow ? "" : "collapse-anim"} `}
        onClick={(event) => {
          event.stopPropagation();
          this.setGameInfoShow(game);
          this.closeRoundHistoryModal(gameId)
        }}
        onMouseEnter={() => {
          this.handleMouseEnter(gameId);
        }}
        onMouseLeave={() => {
          this.handleMouseLeave(gameId);
        }}
      >
        <div
          className={`info-panel`}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className="info-panel-content">
            <div className="text-right">
              <span
                className="btn close-btn"
                onClick={(event) => {
                  event.stopPropagation();
                  this.setGameInfoShow(game);
                }}
              >
                Close
              </span>
            </div>
            <Info
              details={gameInfo}
              currency={this.props.currency}
              locale={this.props.locale}
              gameIndex={i}
              latestBroadcast={this.props.latestBroadcast}
            />
            {gameRelatedLinks && (
              <div className="related-games">
                {gameRelatedLinks.map((route, j) => {
                  let subFiltersRoute;
                  let subFilters;
                  let sortBy;
                  let multiGameRoute;
                  let isLoading;
                  let isLoadingNext;
                  let hasNextPage;
                  let games;
                  let filterRoute;
                  let page;
                  let size = 8;
                  let maxCount = 10;

                  try {
                    multiGameRoute = route.setIn(
                      ["rel"],
                      `related.${i}.${route.get("rel")}`
                    );
                  } catch (err) {}
                  try {
                    filterRoute = multiGameRoute.get("links").find((link) => {
                      return link.get("rel").indexOf("filters");
                    });
                  } catch (err) {}
                  try {
                    subFilters = this.props.filters.getIn([
                      filterRoute.get("rel"),
                      "data",
                      "filters",
                    ]);
                  } catch (err) {}
                  try {
                    sortBy = this.props.filters.getIn([
                      subFiltersRoute.get("rel"),
                      "data",
                      "sortBy",
                    ]);
                  } catch (err) {}
                  try {
                    games = this.props.gamesState.getIn([
                      multiGameRoute.get("rel"),
                      "data",
                    ]);
                  } catch (err) {}
                  try {
                    page = games.get("page");
                  } catch (err) {}
                  try {
                    isLoading = this.props.gamesState.getIn([
                      multiGameRoute.get("rel"),
                      "isLoading",
                    ]);
                  } catch (err) {}
                  try {
                    isLoadingNext = this.props.gamesState.getIn([
                      multiGameRoute.get("rel"),
                      "isLoadingNext",
                    ]);
                  } catch (err) {}
                  try {
                    hasNextPage = games.get("totalPages") > games.get("page");
                    hasNextPage = hasNextPage
                      ? games.getIn(["items"]).size > maxCount
                      : false;
                  } catch (err) {
                    hasNextPage = true;
                  }

                  return (
                    <GamesList
                      key={j}
                      route={multiGameRoute}
                      hasNoFilters={!filterRoute}
                      itemComponent={CategoryType9ListItem}
                      isLoading={isLoading}
                      isLoadingNext={isLoadingNext}
                      hasNextPage={hasNextPage}
                      games={games}
                      fetchGames={() => {
                        if (!hasNextPage) return;
                        let params = new URLSearchParams();
                        params.append("page", page ? page + 1 : 1);
                        params.append("size", size);
                        this.props.games.forEach((game) => {
                          if (game && game.get("gameId")) {
                            params.append("excludedId", game.get("gameId"));
                          }
                        });
                        if (subFilters) {
                          subFilters.forEach((filter) => {
                            filter.get("values").forEach((value) => {
                              if (value.get("toggled") === true) {
                                params.append(
                                  filter.get("id"),
                                  value.get("id")
                                );
                              }
                            });
                          });
                        }
                        if (sortBy) {
                          params.append("sortBy", sortBy);
                        }

                        return this.props.fetchGames(multiGameRoute, params);
                      }}
                      isMobile={this.props.isMobile}
                      onGameItemClickHandler={(item) => {
                        this.launchGame(i, item);
                      }}
                      componentWillUnmount={() => {
                        this.props.clearGames(multiGameRoute);
                      }}
                      imageFormat={this.props.imageFormat}
                      latestBroadcast={this.props.latestBroadcast}
                      currency={this.props.currency}
                      isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
                    />
                  );
                })}
              </div>
            )}
          </div>
          <span
            className="close-icon"
            onClick={(event) => {
              event.stopPropagation();
              this.setGameInfoShow(game);
            }}
          >
            <CloseIcon />
          </span>
        </div>
      </div>
    );
  }

  renderGame(data) {
    const gameId = data.game.get("gameId");
    const showRoundHistoryModal = this.state.gameHistoryModals.get(gameId);
    const animationState = this.state.modalAnimationState.get(gameId);
    const shouldRenderModal =
      showRoundHistoryModal || animationState === "closing";

    let params = {
      gameId: data.game.get("gameId"),
      playType: data.game.get("playType"),
      location: this.props.location,
      url: this.state.gameUrl,
      hideSplash: this.props.hideSplash,
      isMobile: this.props.isMobile,
      appId: this.props.appId,
      target: "_self",
    };

    return (
      <div
        className={`${this.state.multiGameCount > 1 ? "" : ""} game-col ${
          this.state.multiGameCount > 2 ? "" : ""
        } order-${this.state.itemOrder[data.i]}`}
        key={data.i}
        draggable={this.state.multiGameCount > 1}
        onDragStart={this.onDraggingItem}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}
        onDragEnd={this.onDragEnd}
      >
        <div className="game-panel">
          {
            <CommonGameController
              onPreviousClick={this.onPreviousClick}
              history={this.props.history}
              onCloseClickHandler={() => {
                this.onCloseClickHandler();
              }}
              onCloseGameHandler={
                !this.props.isMultiGame
                  ? null
                  : () => {
                      this.onCloseGameHandler(data.i);
                    }
              }
              onRefreshClickHandler={() => {
                this.onRefreshClickHandler(data.i);
              }}
              showGameHistory={this.props.profileGameRoundHistoryLink}
              toggleHistory={() => {
                const gameId = data.game.get("gameId");
                const isModalOpen = this.state.gameHistoryModals.get(gameId);
                
                if (isModalOpen) {
                  this.closeRoundHistoryModal(gameId);
                } else {
                  const gameInfo = this.state.gameInfos.get(gameId);
                  if (gameInfo) {
                    this.setGameHistoryShow(gameInfo);
                  } else {
                    this.props.fetchGame(gameId).then((resp) => {
                      this.setGameInfo(resp.payload);
                      this.setGameHistoryShow(resp.payload);
                    });
                  }
                }
              }}
              showInfo={true}
              toggleInfo={() => {
                this.setGameInfoShow(data.game);
              }}
              params={params}
              gameId={this.props.games.get(data.i).get("gameId")}
              showCashier={this.props.showCashier}
              broadcastCashier={this.props.broadcastCashier}
              showSwitchDevice={this.props.showSwitchDevice}
              broadcastSwitchDevice={(params, gameId) => {
                let singleGame = fromJS([data.game.toJSON(), null, null, null]);
                let gamesEnc = btoa(
                  encodeURIComponent(JSON.stringify(singleGame))
                );

                let newParams = {
                  games: gamesEnc,
                  layout: GamesLayoutType.LAYOUT_1,
                };

                params.location.search = queryString.stringify(newParams);

                this.props.broadcastSwitchDevice(params, gameId);
              }}
              isResponsiveGameDisplayEnabled={
                this.props.isResponsiveGameDisplayEnabled
              }
              onRotateClickHandler={() => {
                this.onRotateClickHandler(data.i);
              }}
            />
          }
          <GameItem
            game={data.game}
            fetchGame={(gameId) => {
              return this.props.fetchGame(gameId).then((resp) => {
                let params = {
                  nav: data.game.get("nav"),
                };

                let relatedLinks = resp.payload.get("links").find((link) => {
                  return link.get("rel") === "related.links";
                });
                this.setGameRelatedLinks(gameId, relatedLinks, params);
                this.setGameInfo(resp.payload);
                this.setGameHistory(resp.payload);
                return resp;
              });
            }}
            fetchGameUrl={(route, gameParams) => {
              return this.props.fetchGameUrl(route, gameParams).then((resp) => {
                return resp;
              });
            }}
            params={params}
            onGameLaunch={this.props.onGameLaunch}
            isResponsiveGameDisplayEnabled={
              this.props.isResponsiveGameDisplayEnabled
            }
            onRotateClickHandler={() => {
              this.onRotateClickHandler(data.i);
            }}
          />
        </div>
        {this.renderInfoPanel(data.i, data.game)}
        {shouldRenderModal && (
          <div 
            className={`modal-backdrop ${animationState}`}
            onClick={() => this.closeRoundHistoryModal(gameId)}
          >
            <div 
              className="modal-content-wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              <RoundHistoryPerGame
                isModal={true}
                gameItem={this.state.gameInfos.get(gameId) || data.game}
                roundHistoryLink={this.state.gameInfos.get(gameId).get("links").find((link) => link.get("rel") === "round-history-per-game.links")}
                onClose={() => this.closeRoundHistoryModal(gameId)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  _renderMiniLobby(data) {
    var filters;
    let filterRoute;
    let gamesRoute;
    let games;
    let sorts;
    var sortBy;
    let activeCategory;
    let filtersIsLoading;
    let enableClearAll;
    let sortingSize = 0;
    let isLoading;
    let isLoadingNext;
    let hasNextPage;
    let page;
    let ListItem = this.props.isMobile
      ? CategoryListItem
      : CategoryType8ListItem;

    try {
      activeCategory = this.props.games.getIn([data.i, "data"]);
    } catch (err) {}
    try {
      filterRoute = this.props.games
        .getIn([data.i, "data", "links"])
        .find((link) => link.get("rel").indexOf("filters") > -1);
      filterRoute = filterRoute.setIn(
        ["rel"],
        `minilobby.${data.i}.${filterRoute.get("rel")}`
      );
    } catch (err) {}
    try {
      filtersIsLoading = this.props.filters.getIn([
        filterRoute.get("rel"),
        "isLoading",
      ]);
    } catch (err) {}
    try {
      gamesRoute = this.props.games
        .getIn([data.i, "data", "links"])
        .find((link) => link.get("rel").indexOf("games") > -1);
      gamesRoute = gamesRoute.setIn(
        ["rel"],
        `minilobby.${data.i}.${gamesRoute.get("rel")}`
      );
    } catch (err) {}
    try {
      games = this.props.gamesState.getIn([gamesRoute.get("rel"), "data"]);
    } catch (err) {}
    try {
      page = games.get("page");
    } catch (err) {}
    try {
      isLoading = this.props.gamesState.getIn([
        gamesRoute.get("rel"),
        "isLoading",
      ]);
    } catch (err) {}
    try {
      isLoadingNext = this.props.gamesState.getIn([
        gamesRoute.get("rel"),
        "isLoadingNext",
      ]);
    } catch (err) {}
    try {
      hasNextPage = games.get("totalPages") > games.get("page");
    } catch (err) {}

    try {
      filters = this.props.filters.getIn([
        filterRoute.get("rel"),
        "data",
        "filters",
      ]);
    } catch (err) {}
    try {
      sorts = this.props.filters.getIn([
        filterRoute.get("rel"),
        "data",
        "sorts",
      ]);
    } catch (err) {}
    try {
      sortBy = this.props.filters.getIn([
        filterRoute.get("rel"),
        "data",
        "sortBy",
      ]);
    } catch (err) {}
    try {
      enableClearAll = this.props.filters.getIn([
        filterRoute.get("rel"),
        "enableClearAll",
      ]);
    } catch (err) {}

    return (
      <div
        className={`${this.state.multiGameCount > 1 ? "" : ""} game-col ${
          this.state.multiGameCount > 2 ? "" : ""
        } order-${this.state.itemOrder[data.i]}`}
        key={data.i}
        draggable={this.state.multiGameCount > 1}
        onDragStart={this.onDraggingItem}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}
        onDragEnd={this.onDragEnd}
      >
        <div className="related-link-panel">
          <div className="game-item related-container">
            <CommonGameController
              history={this.props.history}
              showCashier={this.props.showCashier}
              broadcastCashier={this.props.broadcastCashier}
              onPreviousClick={this.onPreviousClick}
              onCloseClickHandler={() => {
                this.onCloseClickHandler();
              }}
              onCloseGameHandler={
                this.props.isMultiGame
                  ? () => {
                      this.onCloseGameHandler(data.i);
                    }
                  : null
              }
              onRefreshClickHandler={() => {
                this.onRefreshClickHandler(data.i);
              }}
            />
            <div className="mini-lobby-container">
              {this.props.lobbyContent && (
                <>
                  <LobbyGameNavigation
                    content={this.props.lobbyContent}
                    activeCategory={activeCategory}
                    setActiveCategory={(category) => {
                      this.setMiniLobby(data.i, category);
                    }}
                  />
                  <CategoryFiltersComponent
                    filters={filters}
                    filterRoute={filterRoute}
                    fetchFilters={(route) => {
                      let params = new URLSearchParams();
                      if (filters) {
                        filters.forEach((filter) => {
                          filter.get("values").forEach((value) => {
                            if (value.get("toggled") === true) {
                              params.append(filter.get("id"), value.get("id"));
                            }
                          });
                        });
                      }
                      this.props.clearGames(gamesRoute);
                      this.props.fetchFilters(route, params);
                    }}
                    onApplyFilterClickHandler={(filter) => {
                      let selectedFilters = {
                        activeFilter: filter.get("id"),
                        showFilters: true,
                        filterRoute,
                        games,
                      };
                      this.setState({
                        selectedFilters,
                      });
                    }}
                    onSortClick={() => {
                      let selectedFilters = {
                        activeFilter: "sortBy",
                        showFilters: true,
                        filterRoute,
                        games,
                      };
                      this.setState({
                        selectedFilters,
                      });
                    }}
                    onFilterClickHandler={this.props.setActiveFilter}
                    showSelectedFilter={false}
                    games={games}
                    link={gamesRoute}
                    sortBy={sortBy}
                    sorts={sorts}
                    enableClearAll={enableClearAll}
                    clearAllFilters={this.props.clearAllFilters}
                    isMobile={this.props.isMobile}
                    sortingSize={sortingSize}
                    filtersIsLoading={filtersIsLoading}
                  />
                  <CategoryGames
                    route={gamesRoute}
                    hasNoFilters={!filterRoute}
                    refreshList={!filtersIsLoading}
                    itemComponent={ListItem}
                    isMobile={this.props.isMobile}
                    isLoading={isLoading}
                    isLoadingNext={isLoadingNext}
                    hasNextPage={hasNextPage}
                    games={games}
                    sortBy={sortBy}
                    fetchGames={() => {
                      let params = new URLSearchParams();
                      this.props.games.forEach((game) => {
                        if (game && game.get("gameId")) {
                          params.append("excludedId", game.get("gameId"));
                        }
                      });
                      if (filters) {
                        filters.forEach((filter) => {
                          filter.get("values").forEach((value) => {
                            if (value.get("toggled") === true) {
                              params.append(filter.get("id"), value.get("id"));
                            }
                          });
                        });
                      }
                      if (sortBy) {
                        params.append("sortBy", sortBy);
                      }

                      return this.props.fetchGames(gamesRoute, params);
                    }}
                    onGameItemClickHandler={(item) => {
                      this.launchGame(data.i, item);
                    }}
                    imageFormat={this.props.imageFormat}
                    onReachEnd={() => {
                      let params = new URLSearchParams();
                      params.append("page", page + 1);

                      this.props.games.forEach((game) => {
                        if (game && game.get("gameId")) {
                          params.append("excludedId", game.get("gameId"));
                        }
                      });
                      if (filters) {
                        filters.forEach((filter) => {
                          filter.get("values").forEach((value) => {
                            if (value.get("toggled") === true) {
                              params.append(filter.get("id"), value.get("id"));
                            }
                          });
                        });
                      }
                      if (sortBy) {
                        params.append("sortBy", sortBy);
                      }

                      return this.props.fetchGames(gamesRoute, params);
                    }}
                    latestBroadcast={this.props.latestBroadcast}
                    currency={this.props.currency}
                    isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderGameItemBanner(data) {
    const gameId = data.game.get("gameId");
    const showRoundHistoryModal = this.state.gameHistoryModals.get(gameId);
    const animationState = this.state.modalAnimationState.get(gameId);
    const shouldRenderModal =
      showRoundHistoryModal || animationState === "closing";

    let params = {
      gameId: data.game.get("gameId"),
      playType: data.game.get("playType"),
      refresh: data.game.get("refresh"),
      location: this.props.location,
      url: this.state.gameUrl,
      hideSplash: this.props.hideSplash,
      isMobile: this.props.isMobile,
      appId: this.props.appId,
      target: "_self",
    };

    return (
      <div
        className={`${this.state.multiGameCount > 1 ? "" : ""} game-col ${
          this.state.multiGameCount > 2 ? "" : ""
        } order-${this.state.itemOrder[data.i]}`}
        key={data.i}
        draggable={this.state.multiGameCount > 1}
        onDragStart={this.onDraggingItem}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}
        onDragEnd={this.onDragEnd}
      >
        <div className="game-banner-panel">
          {this.state.multiGameCount >= 1 && (
            <CommonGameController
              ref={this.controllerRef}
              history={this.props.history}
              onCloseClickHandler={() => {
                this.onCloseClickHandler();
              }}
              onCloseGameHandler={
                this.props.isMultiGame
                  ? () => {
                      this.onCloseGameHandler(data.i);
                    }
                  : null
              }
              showGameHistory={this.props.profileGameRoundHistoryLink}
              toggleHistory={() => {
                const gameId = data.game.get("gameId");
                const isModalOpen = this.state.gameHistoryModals.get(gameId);

                if (isModalOpen) {
                  this.closeRoundHistoryModal(gameId);
                } else {
                  const gameInfo = this.state.gameInfos.get(gameId);
                  if (gameInfo) {
                    this.setGameHistoryShow(gameInfo);
                  } else {
                    this.props.fetchGame(gameId).then((resp) => {
                      this.setGameInfo(resp.payload);
                      this.setGameHistoryShow(resp.payload);
                    });
                  }
                }
              }}
              onRefreshClickHandler={() => {
                this.onRefreshClickHandler(data.i);
              }}
              showInfo={true}
              toggleInfo={() => {
                this.setGameInfoShow(data.game);
              }}
              params={params}
              gameId={this.props.games.get(data.i).get("gameId")}
              showCashier={this.props.showCashier}
              showSwitchDevice={this.props.showSwitchDevice}
              isInfoHovered={this.state.isHovered}
              onPreviousClick={this.onPreviousClick}
              broadcastCashier={this.props.broadcastCashier}
              broadcastSwitchDevice={(params, gameId) => {
                let singleGame = fromJS([data.game.toJSON(), null, null, null]);
                let gamesEnc = btoa(
                  encodeURIComponent(JSON.stringify(singleGame))
                );

                let newParams = {
                  games: gamesEnc,
                  layout: GamesLayoutType.LAYOUT_1,
                };

                params.location.search = queryString.stringify(newParams);

                this.props.broadcastSwitchDevice(params, gameId);
              }}
            />
          )}
          <GameItemBanner
            game={data.game}
            fetchGame={(gameId) => {
              return this.props.fetchGame(gameId).then((resp) => {
                let params = {
                  nav: data.game.get("nav"),
                };

                let relatedLinks = resp.payload.get("links").find((link) => {
                  return link.get("rel") === "related.links";
                });
                this.setGameRelatedLinks(gameId, relatedLinks, params);
                this.setGameInfo(resp.payload);
                this.setGameHistory(resp.payload);
                return resp;
              });
            }}
            fetchGameUrl={(route, gameParams) => {
              return this.props.fetchGameUrl(route, gameParams).then((resp) => {
                return resp;
              });
            }}
            onGameItemClickHandler={(item) => {
              this.launchGame(data.i, item);
            }}
            latestBroadcast={this.props.latestBroadcast}
            imageFormat={this.props.imageFormat}
            currency={this.props.currency}
            isResponsiveGameDisplayEnabled={
              this.props.isResponsiveGameDisplayEnabled
            }
          />
        </div>
        {this.renderInfoPanel(data.i, data.game)}
        {shouldRenderModal && (
          <div 
            className={`modal-backdrop ${animationState}`}
            onClick={() => this.closeRoundHistoryModal(gameId)}
          >
            <div 
              className="modal-content-wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              <RoundHistoryPerGame
                isModal={true}
                gameItem={this.state.gameInfos.get(gameId) || data.game}
                roundHistoryLink={this.state.gameInfos.get(gameId).get("links").find((link) => link.get("rel") === "round-history-per-game.links")}
                onClose={() => this.closeRoundHistoryModal(gameId)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  _onPreviousClick() {
    /* const fromPath =
      this.props.location.state && this.props.location.state.from;
    this.props.history.push(fromPath); */
    this.props.history.goBack();
  }

  render() {
    if (!this.props.games) return null;

    return (
      <div className="games-modal" ref={this.containerRef}>
        {this.props.isMultiGame && (
          <FloatingGamesLayout
            setMultiGame={this.setMultiGame}
            multiGameLayout={this.props.gamesLayout}
            broadcastGameMode={this.props.broadcastGameMode}
            layout={this.props.stateLayout}
            deviceSize={this.props.deviceSize}
          />
        )}
        <div className="games-container modal">
          <div className="modal-dialog nopadding">
            <div className="modal-content">
              <div className="multi-game-controller-container">
                <CommonMultiGameController
                  history={this.props.history}
                  onCloseClickHandler={this.onCloseClickHandler}
                  onFullscreenHandler={this.onFullscreenHandler}
                  gameFullscreen={this.props.gameFullscreen}
                  setMultiGame={this.setMultiGame}
                  multiGameCount={this.state.multiGameCount}
                  multiGameLayout={this.props.gamesLayout}
                  onRefreshClickHandler={() => {
                    this.onRefreshClickHandler(0);
                  }}
                  showInfo={this.state.multiGameCount === 1}
                  toggleInfo={() => {
                    this.setGameInfoShow(this.props.games.get(0));
                  }}
                  showSwitchDevice={this.props.showSwitchDevice}
                  gameId={
                    this.state.multiGameCount === 1 && this.props.games.get(0)
                      ? this.props.games.get(0).get("gameId")
                      : null
                  }
                  broadcastSwitchDevice={(params, gameId) => {
                    let singleGame = fromJS([
                      this.props.games.get(0).toJSON(),
                      null,
                      null,
                      null,
                    ]);
                    let gamesEnc = btoa(
                      encodeURIComponent(JSON.stringify(singleGame))
                    );

                    let newParams = {
                      games: gamesEnc,
                      layout: GamesLayoutType.LAYOUT_1,
                    };

                    params.location.search = queryString.stringify(newParams);

                    this.props.broadcastSwitchDevice(params, gameId);
                  }}
                  broadcastGameMode={this.props.broadcastGameMode}
                  showCashier={this.props.showCashier}
                  broadcastCashier={this.props.broadcastCashier}
                  location={this.props.location}
                  isMultiGame={this.props.isMultiGame}
                />
              </div>
              <div
                className={`games-row ${this.props.gamesLayout}`}
                ref={this.gamesRef}
              >
                {this.props.games.map((game, i) => {
                  let type;

                  try {
                    type = game.get("type");
                  } catch (err) {}

                  if (type === "lobby") {
                    return this.renderMiniLobby({ i });
                  } else if (
                    game &&
                    (game.get("playType") === "launch.real" ||
                      game.get("playType") === "launch.demo")
                  ) {
                    return this.renderGame({ game, i });
                  } else if (game) {
                    return this.renderGameItemBanner({ game, i });
                  } else {
                    return null;
                  }
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="games-show-more-filters">
          <ShowMoreFilters
            refreshOnRouteChange={false}
            activeFilter={
              this.state.selectedFilters
                ? this.state.selectedFilters.activeFilter
                : null
            }
            filters={
              this.state.selectedFilters
                ? this.props.filters.getIn([
                    this.state.selectedFilters.filterRoute.get("rel"),
                    "data",
                    "filters",
                  ])
                : null
            }
            filtersLink={
              this.state.selectedFilters
                ? this.state.selectedFilters.filterRoute
                : null
            }
            sortBy={
              this.state.selectedFilters
                ? this.props.filters.getIn([
                    this.state.selectedFilters.filterRoute.get("rel"),
                    "data",
                    "sortBy",
                  ])
                : null
            }
            sorts={
              this.state.selectedFilters
                ? this.props.filters.getIn([
                    this.state.selectedFilters.filterRoute.get("rel"),
                    "data",
                    "sorts",
                  ])
                : null
            }
            history={this.props.history}
            games={null}
            onClose={() => {
              let newSelectedFilters = this.state.selectedFilters;
              newSelectedFilters.activeFilter = null;
              this.setState({
                selectedFilters: newSelectedFilters,
              });
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let isMultiGame = state.links.get("isMultiGame");
  let isMobile = state.window.get("isMobile");
  let { games, layout } = queryString.parse(window.location.search);
  let gamesDecrypt = null;
  let showSwitchDevice;
  let lobbyContent = null;
  let gamesLayout = layout ? layout : GamesLayoutType.LAYOUT_1;
  let latestBroadcast;
  let gameLaunchTarget;
  let stateLayout = isMobile ? state.window.get("layout") : null;
  let profileGameRoundHistoryLink = state.profile.get("links").find((link) => {
    return link.get("rel") === "games-round-history.links";
  });

  try {
    lobbyContent = state.pages
      .get("wl-pages")
      .find((page) => {
        return page.get("rel") === "webLobbyMain";
      })
      .get("content");
  } catch (err) {}
  let showCashier;
  let currency = null;

  if (!isMultiGame && !isMobile && games === undefined) {
    return {
      games: null,
    };
  }

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  try {
    showCashier = state.profile.get("showCashier");
  } catch (err) {}

  try {
    gamesDecrypt = fromJS(JSON.parse(decodeURIComponent(atob(games))));
  } catch (err) {}

  try {
    showSwitchDevice = state.profile.get("showSwitchDevice");
  } catch (err) {}

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  //override mobile layout
  if (isMobile) {
    if (gamesLayout === "layout_2a" || gamesLayout === "layout_2b") {
      switch (stateLayout) {
        case "portrait":
          gamesLayout = "layout_2b";
          break;
        default:
          gamesLayout = "layout_2a";
          break;
      }
    }
  }

  try {
    gameLaunchTarget = state.links.get("gameLaunchTarget");
  } catch (err) {}

  return {
    deviceSize: state.window.get("deviceSize"),
    stateLayout,
    isMultiGame,
    isMobile,
    gamesState: state.games,
    games: gamesDecrypt,
    gamesLayout: gamesLayout,
    gameFullscreen: state.config.get("gameFullscreen"),
    imageFormat: state.window.get("imageFormat"),
    currency: currency,
    showSwitchDevice,
    profileGameRoundHistoryLink: profileGameRoundHistoryLink
      ? profileGameRoundHistoryLink
      : null,
    filters: state.filters,
    lobbyContent,
    latestBroadcast,
    locale: state.config.getIn(["locale"]),
    showCashier,
    gameLaunchTarget,
    isResponsiveGameDisplayEnabled: state.links.getIn([
      "isResponsiveGameDisplayEnabled",
    ]),
    isOneClickPlayEnabled: state.links.get("isOneClickPlayEnabled"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    logout: () => dispatchProps.logout(),
    fetchFilters: (route, params) => dispatchProps.fetchFilters(route, params),
    clearAllFilters: (category) => dispatchProps.clearAllFilters(category),
    deleteFilterCategory: (category) =>
      dispatchProps.deleteFilterCategory(category),
    fetchGame: (params) => dispatchProps.fetchGame(params),
    fetchGameUrl: (route, params) => dispatchProps.fetchGameUrl(route, params),
    fetchBalance: () => dispatchProps.fetchBalance(),
    onGameClose: (params) => dispatchProps.onGameClose(params),
    navigateTo: (path) => ownProps.history.push(`${path}`),
    fetchRelatedLinks: (route, params) =>
      dispatchProps.fetchRelatedLinks(route, params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    clearGames: (route) => dispatchProps.clearGames(route),
    setGameFullscreen: (bol) => dispatchProps.setGameFullscreen(bol),
    broadcastSwitchDevice: (gameId, params) =>
      dispatchProps.broadcastSwitchDevice(gameId, params),
    broadcastGameMode: (gameMode) => dispatchProps.broadcastGameMode(gameMode),
    onGameLaunch: (params) => dispatchProps.onGameLaunch(params),
    broadcastCashier: () => dispatchProps.broadcastCashier(),
    setActiveFilter: (category, subCategory, filter) =>
      dispatchProps.setActiveFilter(category, subCategory, filter),
  });
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Games);
